import gql from "graphql-tag";

export const MODEL_FRAGMENT = gql`
	fragment ModelFields on Model {
		id
		name
		relatedModelIds
		therapeuticAreas
		summary
		caseExamples
		measures
		milestones
		financialFlows
		dataTypes
		measuresAndMilestones
		details
		challenges
		type
		scopes
		publicAgreementIds
		modelBlobImage
		image {
			id
			url
			fileName
		}
		isFavorite
		isComparable
	}
`;
export const GET_MODEL_BY_ID = gql`
	${MODEL_FRAGMENT}
	query GetModelById($id: ID!) {
		GetModelById(id: $id) {
			...ModelFields
		}
	}
`;

export const GET_MODELS = gql`
	${MODEL_FRAGMENT}
	query GetModels($where: ModelWhere, $search: String) {
		GetModels(where: $where, search: $search) {
			models {
				...ModelFields
			}
			addedToCompareCount
		}
		GetModelsCount
	}
`;

export const GET_FAVORITE_MODELS = gql`
	${MODEL_FRAGMENT}
	query GetFavoriteModels {
		GetFavoriteModels {
			...ModelFields
		}
	}
`;

export const GET_MODELS_TO_COMPARE = gql`
	${MODEL_FRAGMENT}
	query GetComparableModels {
		GetComparableModels {
			...ModelFields
		}
	}
`;
export const UPDATE_MODEL_FILTERS = gql`
	mutation UpdateUserContextFiltersModels($req: String) {
		UpdateUserContextFiltersModels(req: $req)
	}
`;

export const GET_MODEL_FILTERS = gql`
	query GetModelsFilters {
		GetModelsSourceFilterData {
			challenges
			measures
			dataTypes
			financialFlows
			types
			therapeuticAreas
			scopes
		}
		filters: GetUserFiltersModels
	}
`;

export const GET_FILTERED_MODELS_COUNT = gql`
	query GetFilteredModelsCount($where: ModelWhere) {
		GetModels(where: $where, search: "") {
			unlimited: filteredModelsCount
		}
	}
`;

export const GET_RELATED_MODELS = gql`
	query GetRelatedModels($id: ID!) {
		GetRelatedModels(id: $id) {
			id
			name
			type
			modelBlobImage
			image {
				url
			}
			summary
			isFavorite
			isComparable
		}
	}
`;

export const PUBLIC_AGREEMENT_FRAGMENT = gql`
	fragment PublicAgreementFields on PublicAgreement {
		id
		manufacturers
		formattedManufacturers
		product
		productType
		status
		summary
		models
		formattedModels
		measures
		payerType
		hta
		payer
		archetype
		year
		country {
			id
			name
			ISO_A3
			flag {
				id
				url
				fileName
			}
			region
		}
		formattedCountry
		therapeuticAreas
		diseaseNames
		TADI {
			indication
		}
		uncertainties {
			name
			explanation
		}
		sources
		mechanismOfAction
		renegotiations {
			id
			year
		}
		hasRenegotiations
	}
`;

export const DOWNLOADABLE_PUBLIC_AGREEMENT_FRAGMENT = gql`
	fragment DownloadablePublicAgreementFields on DownloadablePublicAgreement {
		product
		manufacturer
		payer
		summary
		models
		measures
		region
		country
		year
		therapeuticArea
		disease
		indication
		status
		productType
		sourceUrls
	}
`;

export const GET_PUBLIC_AGREEMENTS = gql`
	${PUBLIC_AGREEMENT_FRAGMENT}
	query GetPublicAgreements($where: PublicAgreementWhere, $options: PublicAgreementOptions!, $search: String) {
		GetPublicAgreements(where: $where, options: $options, search: $search) {
			displayedPublicAgreements {
				...PublicAgreementFields
			}
			filteredPublicAgreementsCount
			totalCount
		}
	}
`;

export const GET_PUBLIC_AGREEMENTS_FOR_DOWNLOAD = gql`
	${DOWNLOADABLE_PUBLIC_AGREEMENT_FRAGMENT}
	query GetPublicAgreementForDownload($where: PublicAgreementWhere, $options: PublicAgreementOptions!, $search: String) {
		GetPublicAgreementsForDownload(where: $where, options: $options, search: $search) {
			...DownloadablePublicAgreementFields
		}
	}
`;

export const GET_FILTERED_PUBLIC_AGREEMENT_COUNT = gql`
	query GetFilteredPublicAgreementCount($where: PublicAgreementWhere) {
		GetPublicAgreements(where: $where, options: {}, search: "") {
			unlimited: filteredPublicAgreementsCount
		}
	}
`;

export const GET_PUBLIC_AGREEMENT_BY_ID = gql`
	${PUBLIC_AGREEMENT_FRAGMENT}
	query GetPublicAgreementById($id: ID!) {
		GetPublicAgreementById(id: $id) {
			...PublicAgreementFields
			sources
			TADI {
				therapeuticArea
				name
				indication
			}
			uncertainties {
				name
				explanation
			}
		}
	}
`;

export const GET_PUBLIC_AGREEMENT_UNFURL_DATA = gql`
	query GetPublicAgreementUnfurlData($source: String!) {
		GetPublicAgreementUnfurlData(source: $source) {
			url
			title
			description
			image
			favicon
		}
	}
`;

export const GET_BLOB_IMAGE = gql`
	query GetBlobImage($blobContainerType: String!, $blobName: String!) {
		GetBlobImage(blobContainerType: $blobContainerType, blobName: $blobName)
	}
`;

export const UPDATE_PUBLIC_AGREEMENTS_FILTER = gql`
	mutation UpdateUserFiltersPublicAgreements($req: String) {
		UpdateUserFiltersPublicAgreements(req: $req)
	}
`;

export const GET_PUBLIC_AGREEMENT_PRICES = gql`
	query GetPublicAgreementPrices($id: ID!) {
		GetPublicAgreementPrices(id: $id) {
			description
			company
			productGroup
			currency
			hospclass
			mnfclass
			ppeVatclass
			country
			pcid
			prices {
				effectiveStartDate
				hosp
				mnf
				ppeVat
			}
		}
	}
`;
